/**
 * <RevisionProgramList> — revision programs already grouped by day (template, L0.1).
 *
 * The full-page counterpart of `<RevisionProgramsSection>`: for each group, the precomputed
 * section title (e.g. "Lundi • 06/07/2026" or "Jour 3 (Semaine 1)") followed by that day's
 * `<RevisionProgramCard>`s. Grouping / titles are owned by the view-model — this list only renders.
 * Pure composition — no business/data imports.
 */
import { Stack } from "../../atoms/containers/Stack"
import { RevisionProgramCard } from "../../organisms/RevisionProgramCard"
import { type UIRevisionProgramGroup } from "../../../ports/primary/ui/types"
import { List } from "../../molecules/List"

export type RevisionProgramListProps = {
    groups: UIRevisionProgramGroup[]
}

export function RevisionProgramList(props: RevisionProgramListProps) {
    const { groups } = props

    return (
        <Stack gap="6">
            {/* En-tête de JOUR, pas intitulé de section : il garde le gros titre. */}
            {groups.map((group) => (
                <List key={group.id} title={group.title} titleVariant="title" titleSize="text-lg">
                    {group.programs.map((program) => (
                        <RevisionProgramCard key={program.id} program={program} />
                    ))}
                </List>
            ))}
        </Stack>
    )
}
